import "index.css"
import "syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

// Trap focus within an element
function trapFocus(elem, firstTabbableFocused = true) {
  const tabbable = Array.from(elem.querySelectorAll('select, input, textarea, button, a')).filter(el => el.offsetParent !== null);

  const firstTabbable = tabbable[0];
  const lastTabbable = tabbable[tabbable.length - 1];

  if (firstTabbableFocused && firstTabbable) {
    /* set focus on first input */
    firstTabbable.focus();
  }

  /* redirect last tab to first input */
  if (lastTabbable) {
    lastTabbable.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstTabbable.focus();
      }
    });
  }

  /* redirect first shift+tab to last input */
  if (firstTabbable) {
    firstTabbable.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastTabbable.focus();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  // Mobile Menu
  const btn = document.querySelector("button.mobile-menu-button");
  const menu = document.querySelector(".mobile-menu");
  btn.addEventListener("click", () => {
    menu.classList.toggle("hidden");
  });

  // Dropdown Navigation Menu
  const dropdownButton = document.getElementById("dropdownButton");
  const dropdownMenu = document.getElementById("dropdownMenu");

  function toggleDropdown(dropdownButton, dropdownMenu) {
    const isVisible = dropdownMenu.classList.contains("opacity-100");

    if (isVisible) {
      dropdownMenu.classList.remove("opacity-100", "visible", "block");
      dropdownMenu.classList.add("opacity-0", "invisible", "hidden");
      dropdownButton.classList.remove("text-gray-900");
      dropdownMenu.setAttribute('aria-hidden', true);
    } else {
      dropdownMenu.classList.remove("opacity-0", "invisible", "hidden");
      dropdownMenu.classList.add("opacity-100", "visible", "block");
      dropdownButton.classList.add("text-gray-900");
      dropdownMenu.setAttribute('aria-hidden', false);
      trapFocus(dropdownMenu);
    }
  }

  // Close trapFocus and return focus initiator
  document.querySelectorAll('.js-focus-close').forEach(element => {
    element.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const focusTarget = e.target.getAttribute('data-focus-target');
        document.getElementById(focusTarget).focus();
      }
    });
  });

  // Open dropdown when clicking on button
  dropdownButton.addEventListener("click", (event) => {
    toggleDropdown(dropdownButton, dropdownMenu);
  });

  // Open dropdown when pressing enter or space
  dropdownButton.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      toggleDropdown(dropdownButton, dropdownMenu);
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (event) => {
    if (!dropdownButton.contains(event.target) && !dropdownMenu.contains(event.target)) {
      dropdownMenu.classList.remove("opacity-100", "visible", "block");
      dropdownMenu.classList.add("opacity-0", "invisible", "hidden");
      dropdownButton.classList.remove("text-gray-900");
    }
  });

  // Close dropdown when pressing escape
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      dropdownMenu.classList.remove("opacity-100", "visible", "block");
      dropdownMenu.classList.add("opacity-0", "invisible", "hidden");
      dropdownButton.classList.remove("text-gray-900");
      dropdownButton.focus();
    }
  });

  // --- GA4 Custom Event Tracking ---

  function trackEvent(eventName, params) {
    if (typeof gtag !== "function") return;
    const defaults = {
      page_path: window.location.pathname,
      page_title: document.title
    };
    gtag("event", eventName, Object.assign(defaults, params));
  }

  // Generic click handler via event delegation for [data-track] elements
  document.addEventListener("click", function(event) {
    const tracked = event.target.closest("[data-track]");
    if (!tracked) return;

    const eventName = tracked.getAttribute("data-track");
    const params = {};
    for (const attr of tracked.attributes) {
      if (attr.name.startsWith("data-track-")) {
        const key = attr.name.replace("data-track-", "").replace(/-/g, "_");
        params[key] = attr.value;
      }
    }
    trackEvent(eventName, params);
  });

  // Newsletter form view — fires once when Kit form container scrolls into view
  const formContainers = document.querySelectorAll('[data-track-form="newsletter"]');
  if (formContainers.length > 0) {
    const formObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          trackEvent("newsletter_form_view", {
            form_location: entry.target.closest("[id]")?.id || "unknown"
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    formContainers.forEach(function(container) {
      formObserver.observe(container);
    });
  }

  // Newsletter signup — listen for Kit/ConvertKit postMessage on form submit
  window.addEventListener("message", function(event) {
    if (typeof event.data === "object" && event.data.type === "ck:form:submit") {
      trackEvent("newsletter_signup", {
        form_location: window.location.pathname
      });
    }
  });

  // Newsletter signup — MutationObserver fallback for Kit "thank you" state
  formContainers.forEach(function(container) {
    const mutationObserver = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.textContent && node.textContent.toLowerCase().includes("thank you")) {
            trackEvent("newsletter_signup", {
              form_location: window.location.pathname
            });
            mutationObserver.disconnect();
            return;
          }
        }
      }
    });
    mutationObserver.observe(container, { childList: true, subtree: true });
  });

  // Simplecast player — its 450 KB of scripts start after the page has loaded
  window.addEventListener("load", function() {
    document.querySelectorAll("iframe[data-src]").forEach(function(frame) {
      frame.src = frame.getAttribute("data-src");
    });
  });

  // Episode play — iframe focus detection as proxy for Simplecast player interaction
  const playerContainers = document.querySelectorAll("[data-track-player]");
  if (playerContainers.length > 0) {
    const firedPlayers = new Set();

    setInterval(function() {
      const active = document.activeElement;
      if (active && active.tagName === "IFRAME") {
        const container = active.closest("[data-track-player]");
        if (container && !firedPlayers.has(container)) {
          firedPlayers.add(container);
          trackEvent("episode_play", {
            episode_title: container.getAttribute("data-track-player-title") || "",
            episode_id: container.getAttribute("data-track-player-id") || ""
          });
        }
      }
    }, 1000);
  }

  // Vault card — topic chip selection
  const vaultCard = document.querySelector("[data-vault-card]");
  if (vaultCard) {
    const chips = vaultCard.querySelectorAll("[data-vault-chip]");
    const cta = vaultCard.querySelector("[data-vault-cta]");

    const activeClasses = ["bg-white", "text-maintainable-dark-green"];
    const inactiveClasses = ["bg-transparent", "text-white", "border", "hover:bg-white", "hover:text-maintainable-dark-green"];

    chips.forEach(function(chip) {
      chip.addEventListener("click", function(e) {
        e.preventDefault();

        chips.forEach(function(c) {
          c.classList.remove(...activeClasses);
          c.removeAttribute("data-vault-active");
          inactiveClasses.forEach(function(cls) { c.classList.add(cls); });
        });

        inactiveClasses.forEach(function(cls) { chip.classList.remove(cls); });
        activeClasses.forEach(function(cls) { chip.classList.add(cls); });
        chip.setAttribute("data-vault-active", "");

        cta.href = chip.href;
        cta.textContent = chip.textContent === "All" ? "Browse All Episodes →" : "Browse " + chip.textContent + " Episodes →";
      });
    });
  }

  // Yearbook — photo strip cards open beside the photo on hover, pinned by click/tap
  const strips = document.querySelector("[data-yearbook-strips]");
  if (strips) {
    const page = document.querySelector("main");
    const frames = strips.querySelectorAll(".yearbook-frame");

    function closeAll() {
      frames.forEach(function(frame) {
        frame.classList.remove("yearbook-frame--open");
        frame.closest(".yearbook-strip").classList.remove("yearbook-strip--open");
        frame.querySelector(".yearbook-frame__shot").setAttribute("aria-expanded", "false");
      });
    }

    // Open the card on the side with more room, so it never clips at the page edge
    function placeCard(frame) {
      const pageRect = page.getBoundingClientRect();
      const rect = frame.getBoundingClientRect();
      const cardWidth = frame.querySelector(".yearbook-card").offsetWidth;
      const roomRight = pageRect.right - rect.right;
      const roomLeft = rect.left - pageRect.left;
      frame.classList.toggle("yearbook-frame--flip", roomRight < cardWidth && roomLeft > roomRight);
    }

    function placeAll() { frames.forEach(placeCard); }
    placeAll();
    window.addEventListener("resize", placeAll);

    strips.addEventListener("click", function(event) {
      if (event.target.closest(".yearbook-card__close")) { closeAll(); return; }
      const shot = event.target.closest(".yearbook-frame__shot");
      if (!shot) return;
      const frame = shot.closest(".yearbook-frame");
      const wasOpen = frame.classList.contains("yearbook-frame--open");
      closeAll();
      if (wasOpen) return;
      placeCard(frame);
      frame.classList.add("yearbook-frame--open");
      frame.closest(".yearbook-strip").classList.add("yearbook-strip--open");
      shot.setAttribute("aria-expanded", "true");
      trackEvent("yearbook_card_opened", { episode_slug: frame.querySelector(".yearbook-card__listen").getAttribute("data-track-episode-slug") });
    });

    document.addEventListener("click", function(event) {
      if (!event.target.closest(".yearbook-frame")) closeAll();
    });

    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape") closeAll();
    });
  }
});
